import BPOINT from '@tradera/blueprint/theme/scss/export/breakpoints.scss';

// Explicit list of breakpoints for code completion
const BREAKPOINTS = {
    XS: 'XS',
    SM: 'SM',
    MD: 'MD',
    LG: 'LG',
    XL: 'XL'
};

/**
 * @type {Object.<string, { min: int, max: int, name: string }>}
 */
const BREAKPOINT_SIZES = {};
Array.from(Object.entries(BPOINT))
    .map(([name, size], index, entries) => {
        const min = parseInt(size, 10);
        // Look ahead to next breakpoint entry and get its size minus one as current breakpoint's max size
        const max =
            index + 1 in entries
                ? parseInt(entries[index + 1][1], 10) - 1
                : Number.MAX_SAFE_INTEGER;
        return {
            min,
            max,
            name
        };
    })
    .forEach(breakpoint => {
        BREAKPOINT_SIZES[breakpoint.name] = breakpoint;
    });

export { BREAKPOINTS, BREAKPOINT_SIZES };
